module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "luck-draw-index"
  }, [_c('lucky-draw')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0caf82ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/lucky-drawer/MyLuckDraw.vue
// module id = 601
// module chunks = 1